import { lazy } from 'react';
/** 路由页面懒加载映射，页面越多时只需在此处登记一次。 */
export const pageModules = {
    home: lazy(async () => {
        const module = await import('@/pages/home/HomePage');
        return { default: module.HomePage };
    }),
    editor: lazy(async () => {
        const module = await import('@/pages/editor/EditorPage');
        return { default: module.EditorPage };
    }),
    materialCreation: lazy(async () => {
        const module = await import('@/pages/material-creation/MaterialCreationPage');
        return { default: module.MaterialCreationPage };
    }),
    awards: lazy(async () => {
        const module = await import('@/pages/awards/AwardsPage');
        return { default: module.AwardsPage };
    }),
    awardDetail: lazy(async () => {
        const module = await import('@/pages/awards/AwardProjectDetailPage');
        return { default: module.AwardProjectDetailPage };
    }),
    assets: lazy(async () => {
        const module = await import('@/pages/assets/AssetsPage');
        return { default: module.AssetsPage };
    }),
    projects: lazy(async () => {
        const module = await import('@/pages/projects/ProjectsPage');
        return { default: module.ProjectsPage };
    }),
    projectDetail: lazy(async () => {
        const module = await import('@/pages/project-detail/ProjectDetailPage');
        return { default: module.ProjectDetailPage };
    }),
    projectAssets: lazy(async () => {
        const module = await import('@/pages/project-assets/ProjectAssetsPage');
        return { default: module.ProjectAssetsPage };
    }),
    projectAssetsRecycle: lazy(async () => {
        const module = await import('@/pages/project-assets/ProjectAssetsRecyclePage');
        return { default: module.ProjectAssetsRecyclePage };
    }),
    projectTabContent: lazy(async () => {
        const module = await import('@/pages/project-detail/ProjectTabContent');
        return { default: module.ProjectTabContent };
    }),
    writer: lazy(async () => {
        const module = await import('@/pages/writer/WriterPage');
        return { default: module.WriterPage };
    }),
    recycle: lazy(async () => {
        const module = await import('@/pages/projects/RecyclePage');
        return { default: module.RecyclePage };
    }),
    storyTree: lazy(async () => {
        const module = await import('@/pages/story-tree/StoryTreePage');
        return { default: module.StoryTreePage };
    }),
    storyBranchAnalysis: lazy(async () => {
        const module = await import('@/pages/story-branch-analysis/StoryBranchAnalysisPage');
        return { default: module.StoryBranchAnalysisPage };
    }),
    startPage: lazy(async () => {
        const module = await import('@/pages/start-page/StartPageEditorPage');
        return { default: module.StartPageEditorPage };
    }),
    play: lazy(async () => {
        const module = await import('@/pages/play/ProjectPlayPage');
        return { default: module.ProjectPlayPage };
    }),
    projectManagement: lazy(async () => {
        const module = await import('@/pages/project-management/ProjectManagementPage');
        return { default: module.ProjectManagementPage };
    }),
    projectJoin: lazy(async () => {
        const module = await import('@/pages/join/ProjectJoinPage');
        return { default: module.ProjectJoinPage };
    }),
    personalCenter: lazy(async () => {
        const module = await import('@/pages/personal-center/PersonalCenterPage');
        return { default: module.PersonalCenterPage };
    }),
    pointsCenter: lazy(async () => {
        const module = await import('@/pages/points/PointsCenterPage');
        return { default: module.PointsCenterPage };
    }),
    pointsRules: lazy(async () => {
        const module = await import('@/pages/points/PointsRulesPage');
        return { default: module.PointsRulesPage };
    }),
    pointsPaymentAgreement: lazy(async () => {
        const module = await import('@/pages/points/PointsPaymentAgreementPage');
        return { default: module.PointsPaymentAgreementPage };
    }),
    userAgreement: lazy(async () => {
        const module = await import('@/pages/agreement/UserAgreementPage');
        return { default: module.UserAgreementPage };
    }),
    privacyPolicy: lazy(async () => {
        const module = await import('@/pages/agreement/PrivacyPolicyPage');
        return { default: module.PrivacyPolicyPage };
    }),
};
